
export const ship_calc_max_thruster_quantity = 9999;
export const ship_calc_max_collectors = 100;
export const ship_calc_max_mining_lasers = 30;
export const ship_calc_max_towing_weight = 1000000;
